import TrainsRoundtripController from './controllers/trains-roundtrip-controller';
import TrainsRulesBaseController from '../trains-base/controllers/trains-rules-base-controller';
import TrainsSearchFormController from './controllers/trains-search-form-controller';
import TrainsOnewayController from './controllers/trains-oneway-controller';
import TrainsResultsController from './controllers/trains-results-controller';
import TrainsHeaderController from './controllers/trains-headers-controller';
import TrainsFiltersController from './controllers/trains-filters-controller';
import TrainsCarouselController from './controllers/trains-carousel-controller';
import TrainsListController from './controllers/trains-list-controller';
import TrainsClearFiltersController from './controllers/trains-clear-filters-controller';

import templateMainTrains from '../trains-base/templates/flights/trains-tabs.html';
import templateMainTrainsRoundtrip from './../train/templates/trains-roundtrip.html';
import templateMainTrainsOneway from '../trains-base/templates/flights/trains-oneway.html';
import templateMainTrainsResults from './templates/train-results.html';
import templateMainTrainsHeader from '../trains-base/templates/flights/trains-results-header.html';
import templateMainTrainsFilter from '../trains-base/templates/flights/trains-filters.html';
import templateMainTrainsCarousel from '../trains-base/templates/flights/trains-carousel.html';
import templateMainTrainsList from './../train/templates/train-list.html';
import templateMainTrainsClear from '../trains-base/templates/flights/trains-clear-filters.html';
import templateTrainsRules from '../trains-base/templates/flights/trains-rules.html';

export const trainStates = {
    MAIN: 'main.trains',
    ROUNDTRIP: 'main.trains.roundtrip',
    ONEWAY: 'main.trains.oneway',
    RESULTS: 'main.trains.results',
    RULES: 'main.trains.results.rules',
};

export default function TrainRoutes(
    $stateProvider,
    $urlRouterProvider
) {
    'ngInject';

    $urlRouterProvider.when('/search/trains', '/search/trains/roundtrip');
    $stateProvider // eslint-disable-line
        .state(trainStates.MAIN, {
            url: '/trains',
            views: {
                '': {
                    template: templateMainTrains,
                    controller: TrainsSearchFormController,
                    resolve: {
                        settingsCabinClasses: ['staticDataGetter', function(staticDataGetter) {
                            return staticDataGetter.getTrainsCabinClasses();
                        }],
                        fareTypesInited: function(flightFareService) {
                            'ngInject';
                            return flightFareService.getFareTypes();
                        },
                    },
                },
            },
            resolve: {
                trainsFactory: function(trainsFactoryConstructor) {
                    'ngInject';
                    return new trainsFactoryConstructor('trains'); // eslint-disable-line
                },
                timeSlots: function(staticDataGetter) {
                    'ngInject';
                    return staticDataGetter.getTimeSlots();
                },
            },
            onEnter: ['$rootScope', function($rootScope) {
                $rootScope.pageHeading = 'Eurostar search';
            }],
        })
        .state(trainStates.ROUNDTRIP, {
            url: '/roundtrip',
            template: templateMainTrainsRoundtrip,
            controller: TrainsRoundtripController,
            controllerAs: 'trainsRoundtripCtrl',
        })
        .state(trainStates.ONEWAY, {
            url: '/oneway',
            template: templateMainTrainsOneway,
            controller: TrainsOnewayController,
        })

        .state(trainStates.RESULTS, {
            url: '/results',
            views: {
                '@main': {
                    template: templateMainTrainsResults,
                    controller: TrainsResultsController,
                    controllerAs: 'trainsResultsCtrl',
                },
                [`page_title@${trainStates.RESULTS}`]: {
                    template: templateMainTrainsHeader,
                    controller: TrainsHeaderController,
                    controllerAs: 'trainsHeaderCtrl',
                },
                [`resultsFilters@${trainStates.RESULTS}`]: {
                    template: templateMainTrainsFilter,
                    controller: TrainsFiltersController,
                },
                [`resultsCarousel@${trainStates.RESULTS}`]: {
                    template: templateMainTrainsCarousel,
                    controller: TrainsCarouselController,
                },
                [`resultsFlights@${trainStates.RESULTS}`]: {
                    template: templateMainTrainsList,
                    controller: TrainsListController,
                },
                [`flightsClearFilters@${trainStates.RESULTS}`]: {
                    template: templateMainTrainsClear,
                    controller: TrainsClearFiltersController,
                },
            },
        })

        .state(trainStates.RULES, {
            url: '/rules?fare&recommendation&adult&child&infant&search&groups&anchor&culture',
            resolve: {
                anchorLink: ['$stateParams', function($stateParams) {
                    return $stateParams.anchor;
                }],
                rules: ['$stateParams', 'trainsFactory', function($stateParams, trainsFactory) {
                    return trainsFactory.getRules({
                        searchId: $stateParams.search,
                        fareId: $stateParams.fare,
                        recommendationId: $stateParams.recommendation,
                        adultCount: $stateParams.adult,
                        childCount: $stateParams.child,
                        infantCount: $stateParams.infant,
                        flightGroups: $stateParams.groups,
                        culture: $stateParams.culture,
                    });
                }],
            },
            views: {
                '@main': {
                    template: templateTrainsRules,
                    controller: TrainsRulesBaseController,
                },
            },
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/train-routes.js